import { useEffect, useState } from "react";
import { motion, AnimatePresence, useScroll, useSpring } from "framer-motion";
import { MessageCircle, ArrowUp } from "lucide-react";
import { Button } from "@/components/ui/button";
import { BRAND } from "@/data/content";
import { useQuote } from "@/context/QuoteContext";

const Floating = () => {
  const { openQuote } = useQuote();
  const [showTop, setShowTop] = useState(false);
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { stiffness: 120, damping: 30, mass: 0.3 });

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 600);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      {/* scroll progress */}
      <motion.div
        style={{ scaleX }}
        className="fixed top-0 left-0 right-0 h-1 bg-brand-green origin-left z-[60]"
        data-testid="scroll-progress"
      />

      {/* WhatsApp */}
      <a
        href={`https://wa.me/${BRAND.whatsapp}`}
        target="_blank"
        rel="noreferrer"
        data-testid="whatsapp-float"
        aria-label="Chat on WhatsApp"
        className="fixed left-4 md:left-6 bottom-24 md:bottom-6 z-50 grid place-items-center h-14 w-14 rounded-full bg-[#25D366] text-white shadow-lift hover:scale-110 transition-transform"
      >
        <MessageCircle className="h-7 w-7" />
        <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-30" />
      </a>

      {/* back to top */}
      <AnimatePresence>
        {showTop && (
          <motion.button
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.8 }}
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            data-testid="back-to-top"
            aria-label="Back to top"
            className="fixed right-4 md:right-6 bottom-40 md:bottom-24 z-50 grid place-items-center h-12 w-12 rounded-full bg-white border border-slate-200 text-brand-navy shadow-soft hover:bg-brand-grey transition-colors"
          >
            <ArrowUp className="h-5 w-5" />
          </motion.button>
        )}
      </AnimatePresence>

      {/* mobile sticky CTA */}
      <div className="lg:hidden fixed bottom-0 inset-x-0 z-40 glass border-t border-slate-100 px-4 py-3" data-testid="mobile-sticky-cta">
        <Button
          onClick={() => openQuote("mobile-sticky")}
          data-testid="mobile-sticky-quote-btn"
          className="w-full h-12 rounded-full bg-brand-yellow text-brand-navy font-semibold hover:bg-[#f0bd1f]"
        >
          Get Free Quote
        </Button>
      </div>
    </>
  );
};

export default Floating;
